module.exports = __webpack_public_path__ + "static/cp-logo-blue.decb03cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp-logo-blue.png
// module id = ./src/assets/cp-logo-blue.png
// module chunks = 114276838955818